import { cn } from 'src/lib/utils';

type ISummaryCard = {
  title: string;
  description?: string;
  descriptionStyle?: 'italic' | 'normal';
  icon: React.ElementType;
  badge?: React.ReactNode;
};

const SummaryCard = ({ title, description, icon, descriptionStyle, badge }: ISummaryCard) => {
  const Icon = icon;

  return (
    <div className="group flex items-center gap-3 bg-accent shadow-sm rounded-lg p-4 has-[.group\/description]:items-start">
      <Icon className="size-3.5 text-foreground shrink-0 group-has-[.group\/description]:mt-1" />
      <div className="grow">
        <h2 className="text-sm font-semibold text-foreground">{title}</h2>
        {description && (
          <p
            className={cn(
              'group/description text-foreground/80 text-xs',
              descriptionStyle === 'italic' ? 'italic' : 'font-normal',
            )}
          >
            {description}
          </p>
        )}
      </div>
      {badge}
    </div>
  );
};

export { SummaryCard, type ISummaryCard };
